import type { ApiKeyDetails } from '@/api/api_key/apiKeyModel'

export interface State {
  modalConfirmApiKeyActived: boolean
  apiKeyDatas: Array<ApiKeyDetails>
}

const state = (): State => ({
  modalConfirmApiKeyActived: false,
  apiKeyDatas: [] as Array<ApiKeyDetails>,
})

export default state
